export async function recycleMapSession(input: { full_student_id: string }): Promise<any> {
  try {
    const baseUrl = 'https://qeeujv9hyb.execute-api.us-east-1.amazonaws.com/prod';
    const apiKey = 'atADP8hxz37kKYSFyjvF39PHFlBZiHuf9OEkA8G4';

    const response = await fetch(`${baseUrl}/api/proctor/students/action`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify({
        studentId: input.full_student_id,
        action: 'recycle',
        type: 'resume',
      }),
    });

    if (response.ok) {
      const responseData = await response.text();
      return {
        success: true,
        message: 'Session recycled successfully',
        data: responseData,
      };
    } else {
      const errorText = await response.text();
      throw new Error(
        `Failed to recycle session: ${response.status} ${response.statusText} - ${errorText}`
      );
    }
  } catch (error) {
    console.error('Error recycling session:', error);
    throw error;
  }
}
